import { Sistema } from './sistema.model';
import { UsuarioSistema } from './usuario-sistema.model';

export class UsuarioRepresentante {

  id: number;
  representado: UsuarioSistema;
  representante: UsuarioSistema;
  sistema: Sistema;
}
